<rt-form-field [required]="true">
  <rt-label>
    {{ 'tlc.ask_hr.form_template_create.title' | translate }}
  </rt-label>
  <rt-name-symbol-input
    [formErrors]="errors().name"
    [rtProtectedControl]="askTemplateForm().controls.name"
    [nameControl]="askTemplateForm().controls.name"
    [symbolControl]="askTemplateForm().controls.symbol"
    [fallbackSymbol]="{ name: 'insert-emoticon', type: 'icon', source: 'internal' }"
    [placeholder]="'tlc.ask_hr.form_template_create.title_placeholder' | translate"
  />
</rt-form-field>
<rt-form-field>
  <rt-label>
    {{ 'tlc.ask_hr.form_template_create.description' | translate }}
  </rt-label>
  <rt-wysiwyg
    prosemirrorBasicConfig
    [rtProtectedControl]="askTemplateForm().controls.descriptionJson"
    [formControl]="askTemplateForm().controls.descriptionJson"
    [placeholder]="'tlc.ask_hr.form_template_create.description_placeholder' | translate"
    class="ng-errors"
  />
</rt-form-field>
<rt-form-field>
  <rt-toggle
    [rtProtectedControl]="askTemplateForm().controls.prioritySelectionEnabled"
    [formControl]="askTemplateForm().controls.prioritySelectionEnabled"
  >
    <rt-heading>
      {{ 'tlc.ask_hr.form_template_create.enable_priority_selection' | translate }}
    </rt-heading>
    <p>
      {{ 'tlc.ask_hr.form_template_create.enable_priority_selection_description' | translate }}
    </p>
  </rt-toggle>
</rt-form-field>
<rt-form-field
  [required]="autoAssignmentsRequired()"
  [hints]="['tlc.ask_hr.form_template_create.automatically_assign_to_description' | translate]"
>
  <rt-label>{{ 'tlc.ask_hr.form_template_create.automatically_assign_to' | translate }}</rt-label>
  <team-members-multiselect
    selectorScope="ask-hr-select"
    [selectedMembers]="selectedMembers()"
    [rtProtectedControl]="askTemplateForm().controls.autoAssignments"
    [control]="askTemplateForm().controls.autoAssignments"
    [(cachedSelectedMembers)]="cachedSelectedMembers"
  />
</rt-form-field>
<rt-form-field>
  <rt-toggle
    [rtProtectedControl]="askTemplateForm().controls.active"
    [formControl]="askTemplateForm().controls.active"
  >
    <rt-heading>
      {{ 'tlc.ask_hr.form_template_create.allow_submissions' | translate }}
    </rt-heading>
    <p>
      {{ 'tlc.ask_hr.form_template_create.allow_submissions_description' | translate }}
    </p>
  </rt-toggle>
</rt-form-field>
